module.exports = __webpack_public_path__ + "img/Inspection2.d49f8b6e.png";